var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Defaults, P, PCSS, ViewChild, Utils, Components } from '@pacem/pacem-core';
import { PacemFxElement } from './types';
//namespace Pacem.Components.Fx {
const PULSE_CSS = "pulse";
const SVG_NS = 'http://www.w3.org/2000/svg';
function buildAnimationName(id) {
    return `${PCSS}-fx-pulse-${id}`;
}
function ensureCssAnimation(id, args, rx = '0', ry = rx) {
    const selector = 'style#' + id;
    const existing = document.querySelector(selector);
    if (Utils.isNull(existing)) {
        const newStyle = document.createElement('style');
        newStyle.id = id;
        document.head.appendChild(newStyle);
    }
    const css = document.querySelector(selector);
    const w = args.width, h = args.height, dim = Math.max(w, h), x = .5 * (dim - w), y = .5 * (dim - h);
    css.sheet.insertRule(`@keyframes ${buildAnimationName(id)} {
    0%{
        opacity: .25; stroke-thickness: 0; rx: ${rx}; ry: ${ry}; x: ${x}px; y: ${y}px; width: ${args.width}px; height: ${args.height}px;
    }
    50%{
        width: ${args.width}px; height: ${args.height}px; transform: scale(1); stroke-width: 10px; rx: ${rx}; ry: ${ry}; opacity: .333; x: ${x}px; y: ${y}px; width: ${w}px; height: ${h}px;
    }
    80%{
        stroke-width: 10px;
    }
    100%{
        opacity: 0; rx: 50%; ry: 50%; transform: scale(2); stroke-width: 0; width: ${dim}px; height: ${dim}px; x: 0; y: 0
    }
}`, 0);
    for (let j = css.sheet.rules.length - 1; j > 0; j--) {
        css.sheet.deleteRule(j);
    }
    return css;
}
let PacemFxPulseElement = class PacemFxPulseElement extends PacemFxElement {
    constructor() {
        super();
        this._resizeHandler = (e) => {
            this._pulse(e.detail);
        };
        this.#key = Utils.uniqueCode();
    }
    #key;
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._pulse();
    }
    disconnectedCallback() {
        if (!Utils.isNull(this._sheet)) {
            this._sheet.remove();
            this._sheet = null;
        }
        super.disconnectedCallback();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'disabled' && !first) {
            this._pulse();
        }
    }
    _pulse(size = this._resize.currentSize) {
        const inert = Utils.isNull(this.target) || Utils.isNull(size) || !(size.height > 0) || !(size.width > 0);
        this._resize.disabled = this.disabled;
        if (this.disabled || inert) {
            Utils.addClass(this, 'pulse-off');
            return;
        }
        Utils.removeClass(this, 'pulse-off');
        const rect = size;
        const style = getComputedStyle(this.target);
        const css = this.style;
        const dim = Math.max(rect.width, rect.height);
        css.width = dim + 'px';
        css.height = dim + 'px';
        css.top = (rect.top + .5 * (rect.height - dim)) + 'px';
        css.left = (rect.left + .5 * (rect.width - dim)) + 'px';
        const rect1 = this._rect1, rect2 = this._rect2;
        const css1 = rect1.style, css2 = rect2.style;
        this._sheet = ensureCssAnimation(this.#key, size, style.borderTopLeftRadius);
        const animationName = buildAnimationName(this.#key);
        css1.animation = css2.animation = `${animationName} both cubic-bezier(0.37, 0, 0.63, 1) 1.25s infinite`;
        css2.animationDelay = '.175s';
    }
};
__decorate([
    ViewChild(P + '-resize')
], PacemFxPulseElement.prototype, "_resize", void 0);
__decorate([
    ViewChild('svg')
], PacemFxPulseElement.prototype, "_svg", void 0);
__decorate([
    ViewChild('svg > rect[rect1]')
], PacemFxPulseElement.prototype, "_rect1", void 0);
__decorate([
    ViewChild('svg > rect[rect2]')
], PacemFxPulseElement.prototype, "_rect2", void 0);
PacemFxPulseElement = __decorate([
    CustomElement({
        tagName: P + '-fx-pulse', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-resize target="{{ :host.target }}" watch-position="true" on-${Components.ResizeEventName}=":host._resizeHandler($event)"></${P}-resize>
<svg class="${PULSE_CSS}" xmlns="${SVG_NS}">
    <rect rect1 /><rect rect2 />
</svg>`
    })
], PacemFxPulseElement);
export { PacemFxPulseElement };
